import { ref } from "vue";
import { createPinia, defineStore } from "pinia";
import { IAppConfiguration } from "IAppConfiguration";

let initData: IAppConfiguration | null = null;

export const getConfiguration = async (hostUrl : string, portalUrl: string, signalRUrl: string) => {
  const data = await fetch(`${portalUrl}settings/vue`);
  const config = await data.json();
  const appConfig: IAppConfiguration = {
    title: config.title,
    hostUrl: hostUrl,
    portalUrl: portalUrl,
    apiUrl: config.apiUrl,
    identityUrl: config.identityUrl,
    signalRUrl: signalRUrl
  };

  initData = { ...appConfig };

  return initData;
};

export const createStore = (initStoreData: IAppConfiguration) => {
  initData = { ...initStoreData };
  return createPinia();
};

export const useAppConfigurationStore = defineStore("appConfiguration", () => {
  const title = ref(initData.title);
  const portalUrl = ref(initData.portalUrl);
  const signalRUrl = ref(initData.signalRUrl);
  
  function data() {
    return initData;
  }

  return { data, title, portalUrl, signalRUrl };
});
